module.exports = __webpack_public_path__ + "static/media/train.c116e81f.svg";